import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#1A1A1A] text-[#FAF8F5] py-16">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div data-testid="footer-brand-section">
            <h2 className="font-serif font-bold tracking-tight text-[#1E3A8A] mb-4" style={{ fontSize: '28px' }} data-testid="footer-logo">
              De Azraa
            </h2>
            <p className="text-sm text-[#C9A84C] italic font-serif tracking-wide" data-testid="footer-tagline">
              Pure Comfort. Timeless Luxury.
            </p>
          </div>

          {/* Quick Links */}
          <div data-testid="footer-links-section">
            <h4 className="text-xs tracking-[0.2em] uppercase font-semibold mb-4" data-testid="footer-links-title">
              Quick Links
            </h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" data-testid="footer-link-home" className="text-sm hover:text-[#C9A84C] transition-colors">
                Home
              </Link>
              <Link to="/suites" data-testid="footer-link-suites" className="text-sm hover:text-[#C9A84C] transition-colors">
                Suites
              </Link>
              <Link to="/amenities" data-testid="footer-link-amenities" className="text-sm hover:text-[#C9A84C] transition-colors">
                Amenities
              </Link>
              <Link to="/gallery" data-testid="footer-link-gallery" className="text-sm hover:text-[#C9A84C] transition-colors">
                Gallery
              </Link>
              <Link to="/about" data-testid="footer-link-about" className="text-sm hover:text-[#C9A84C] transition-colors">
                About
              </Link>
              <Link to="/contact" data-testid="footer-link-contact" className="text-sm hover:text-[#C9A84C] transition-colors">
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div data-testid="footer-contact-section">
            <h4 className="text-xs tracking-[0.2em] uppercase font-semibold mb-4" data-testid="footer-contact-title">
              Contact
            </h4>
            <div className="flex flex-col gap-3">
              <a href="tel:+2348066722221" data-testid="footer-phone-link" className="flex items-center gap-2 text-sm hover:text-[#C9A84C] transition-colors">
                <Phone size={16} strokeWidth={1.5} />
                +234 806 672 2221
              </a>
              <a href="mailto:Azraalux@gmail.com" data-testid="footer-email-link" className="flex items-center gap-2 text-sm hover:text-[#C9A84C] transition-colors">
                <Mail size={16} strokeWidth={1.5} />
                Azraalux@gmail.com
              </a>
              <div className="flex items-start gap-2 text-sm" data-testid="footer-address">
                <MapPin size={16} strokeWidth={1.5} className="mt-1 flex-shrink-0" />
                <span>Plot 10/9 Udoka Housing Estate Phase 1, Awka, Anambra State, Nigeria</span>
              </div>
            </div>
          </div>

          {/* Hours & Social */}
          <div data-testid="footer-hours-section">
            <h4 className="text-xs tracking-[0.2em] uppercase font-semibold mb-4" data-testid="footer-hours-title">
              Hours
            </h4>
            <p className="text-sm mb-6" data-testid="footer-hours-text">Open 24 Hours</p>
            
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/deazraa"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="hover:text-[#C9A84C] transition-colors"
                aria-label="Instagram"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
              <a
                href="https://wa.me/2348066722221"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="hover:text-[#C9A84C] transition-colors"
                aria-label="WhatsApp"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" />
                  <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-[#FAF8F5]/10 mt-12 pt-8 text-center">
          <p className="text-xs text-[#FAF8F5]/60" data-testid="footer-copyright">
            © {new Date().getFullYear()} De Azraa Luxury Hotel Apartments. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;